import { render } from "./armstrong.vue?vue&type=template&id=3f3c1d1e&scoped=true"
import script from "./armstrong.vue?vue&type=script&lang=js"
export * from "./armstrong.vue?vue&type=script&lang=js"

import "./armstrong.vue?vue&type=style&index=0&id=3f3c1d1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f3c1d1e"]])

export default __exports__